import { Directive, ElementRef, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TalkService } from '../components/talk-dialog/talk-dialog.component';
import { Router } from '@angular/router';

/// For HTML the page did not template - a SitePage's body, a post, an FAQ answer - drawn with [innerHTML]: its links
/// are plain <a href>, and a click on a root-relative one ("/help/returns") would reload the whole app. This hands
/// such a click to the router instead, and scrolls to an in-page anchor ("#delivery") itself - with <base href="/">
/// the browser reads "#delivery" as the home page's. A click with a modifier key, a middle click, a link with a
/// target or a download, and a link off the site keep the browser's own behaviour.
@Directive({
    selector: '[appRouterLinks]'
})
export class RouterLinksDirective {
    constructor(private host: ElementRef<HTMLElement>, private router: Router, @Inject(DOCUMENT) private document: Document, private talk: TalkService) { }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        let element = event.target as HTMLElement;
        while (element && element !== this.host.nativeElement && element.tagName !== 'A') {
            element = element.parentElement;
        }
        if (!element || element.tagName !== 'A') {
            return;
        }

        const href = element.getAttribute('href') || '';
        const target = element.getAttribute('target');
        if ((target && target !== '_self') || element.hasAttribute('download')) {
            return;
        }

        // "Talk to us" in the seller pages' text opens its pop-up (the owner, 2026-11-02).
        const talk = this.talk.kindFor(href, this.document);
        if (talk) {
            event.preventDefault();
            this.talk.open(talk);
            return;
        }

        if (href.startsWith('#') && href.length > 1) {
            const anchor = this.document.getElementById(decodeURIComponent(href.substring(1)));
            if (anchor) {
                event.preventDefault();
                anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
        }

        // Root-relative only: "//host" is another site.
        if (/^\/(?![\/\\])/.test(href)) {
            event.preventDefault();
            this.router.navigateByUrl(href);
        }
    }
}
